function formSendSuccess() {

  const urlPath = window.location.pathname;
    
  // URLパラメーターに customer_posted=true が入っているかチェック
  const urlParams = new URLSearchParams(window.location.search);

  const post_stat_key = (urlPath.includes('contact')) ? 'contact_posted' : 'customer_posted';

  const isPosted = urlParams.get(post_stat_key) === 'true';
  console.debug(isPosted);


  // const pageTitle = document.querySelector('.main-page-title');
  const pageBody = document.querySelector('.main-page-body');
  const form = document.querySelector('.custom-form');
  if (isPosted) {

    // 送信成功時の処理
    console.debug('送信成功');
    // pageBody.style.display = 'none';
    pageBody.parentElement.style.display = 'none';
    form.classList.add('posted');
    // pageTitle.style.display = 'none';
  }
}


document.addEventListener('DOMContentLoaded', function () {

  formSendSuccess();

  const submitBtn = document.getElementById('submit-button');
  const scrollBoxes = document.querySelectorAll('.scroll-condition');

  // scrollBoxes は NodeList なので length で判定する
  if (!submitBtn || scrollBoxes.length === 0) return;

  // 初期状態：無効化
  submitBtn.disabled = true;

  // 全ての .scroll-condition が最下部まで到達しているか判定
  function allScrolledToEnd() {
    return Array.from(scrollBoxes).every((box) => {
      return box.classList.contains('scroll-ended');
    });
  }

  // ボタン状態の更新
  function updateSubmitState() {
    submitBtn.disabled = !allScrolledToEnd();
  }

  
  // スクロールが最下部まで完了したかどうかをチェックし、それに応じてクラスを付与/削除
  function checkScrollEnded(box) {
    const threshold = 20; // 誤差許容(px)

    const scrollBottom = box.scrollTop + box.clientHeight;
    const maxScroll = box.scrollHeight;
    if (scrollBottom >= maxScroll - threshold) {
      box.classList.add('scroll-ended');
      box.next
    }
    // else {
    //   box.classList.remove('scroll-ended');
    // }
  }
  
  // 各スクロール要素のスクロールが最下部まで完了したかどうかをチェック
  function checkAllScrollEnded() {
    scrollBoxes.forEach((box) => {
      checkScrollEnded(box);
    });
  }
  
  // スクロールイベント時にチェックを行う
  scrollBoxes.forEach((box) => {
    box.addEventListener('scroll', checkAllScrollEnded, { passive: true });
  });

  // 初回チェック（既に最下部のケースにも対応）
  updateSubmitState();

  // 各スクロール要素を監視
  scrollBoxes.forEach((box) => {
    box.addEventListener('scroll', updateSubmitState, { passive: true });
  });

  const form = document.querySelector('.custom-form');

  // function toggleLoading() {
    
  //   submitBtn.classList.toggle('loading');
  //   return false;
  // }
  // submitBtn.addEventListener('click', toggleLoading);

  // console.debug(form);

  form.addEventListener('submit', (e) => {

    console.debug(e);
    // e.preventDefault(); // 送信を無効化

    // どの送信ボタンで送られたか（Enter対応）
    const btn = e.submitter || form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.classList.add('loading');

    btn.disabled = true;               // 多重送信防止
    btn.setAttribute('aria-busy', 'true');
    // この後は通常のナビゲーションでページ遷移
  });

});
